import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IInstaller} from "../../shared/model/installer.model";

type EntityResponseType = HttpResponse<IInstaller>;
type EntityArrayResponseType = HttpResponse<IInstaller[]>;

@Injectable({providedIn: 'root'})
export class InstallerService {
  public resourceUrl = SERVER_API_URL + 'api/installers';

  constructor(protected http: HttpClient) {
  }

  create(installer: IInstaller): Observable<EntityResponseType> {
    return this.http
      .post<IInstaller>(this.resourceUrl, installer, {observe: 'response'});
  }

  update(installer: IInstaller): Observable<EntityResponseType> {
    return this.http
      .put<IInstaller>(this.resourceUrl, installer, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IInstaller>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<IInstaller[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }
}
